import { servicesURL } from '.';
import { AxiosInstance } from 'axios';
import { createAuthenticatedApi } from './axios-client';

export type Service = {
  id: string;
  name: string;
  durationInMinutes: number;
};

export type ServiceWriteModel = Omit<Service, 'id'>;

function getServiceApi(): AxiosInstance {
  return createAuthenticatedApi(servicesURL);
}

export async function createService(
  service: ServiceWriteModel,
): Promise<Service> {
  const api = getServiceApi();

  const res = await api.post('', service);

  return res.data as Service;
}
export async function updateService(
  id: string,
  service: ServiceWriteModel,
): Promise<Service> {
  const api = getServiceApi();

  const res = await api.put(`/${id}`, service);

  return res.data as Service;
}
export async function getAllServices(): Promise<Service[]> {
  const api = getServiceApi();

  const res = await api.get('');

  return res.data as Service[];
}

export async function getServiceByID(id: string): Promise<Service> {
  const api = getServiceApi();

  const res = await api.get(`/${id}`);

  return res.data as Service;
}

export async function deleteService(id: string): Promise<void> {
  const api = getServiceApi();

  await api.delete(`/${id}`);
}
